import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toIconColor',
  standalone: true,
})
export class ToIconColorPipe implements PipeTransform {
  transform(clase: string): string {
    return clase.replace('nav-', 'icon-');
  }
}
